/*
 * Public API Surface of ngx-lib/field-title
 */
export * from './field-title.module';
export * from './field-title.component';
